import { Link, useParams } from "react-router-dom"
import { SingleTutor } from "../../components/profile"
import Styles from './users.module.scss'
import { FiArrowLeft, FiCheckCircle, FiX } from "react-icons/fi";
import { useEffect, useState } from "react";
import { getTutorFullProfile, moderateTutor } from "../../store/profile/profileActions";
import { useDispatch } from "react-redux";
import { getImage } from "../../utils";
const TutorModerate = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const [profile, setProfile] = useState(0)
    const [activeTab, setActiveTab] = useState(0)
    const [isModerating, setIsModerating] = useState(false)
    const [showRejectDialog, setShowRejectDialog] = useState(false)
    const [moderated, setModerated] = useState(false)
    const [decision, setDecision] = useState(false)
    const [rejectNote, setRejectNote] = useState("")
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        dispatch(getTutorFullProfile(params))
            .unwrap()
            .then(v => {
                setProfile({
                    ...v, ...v.userId,
                    avatar: v.userId.avatar?.path,
                    certificates: v.certificate
                })
                setIsLoading(false)
            })
    }, [])

    const handleModerateUser = (decision) => {
        setDecision(decision)
        if (decision) {
            setShowRejectDialog(false)
            setRejectNote("")
            setIsModerating(true)
            return
        }

        setIsModerating(false)
        setShowRejectDialog(true)
    }

    const dispatchModerate = () => {
        dispatch(moderateTutor({ tutorId: params.tutorId, decision, note: decision ? "" : rejectNote }))
            .then(() => {
                setIsModerating(false)
                setShowRejectDialog(false)
                setModerated(true)
            })
    }

    const ModerationAction = () => {
        return !isModerating ? <div className="flex justify-center gap-5">
            <button className="text-white bg-nt-blue py-2 px-4 rounded-md" onClick={() => handleModerateUser(true)}>Accept</button>
            <button className="text-white bg-nt-red py-2 px-4 rounded-md" onClick={() => handleModerateUser(false)}>Reject</button>
        </div> : <div className="">
            <p className="text-nt-blue text-center mb-3">Are you sure to accept this profile ?</p>
            <div className="justify-center flex gap-5">
                <button onClick={() => dispatchModerate()} className="text-white bg-nt-blue py-2 px-4 rounded-md">Yes</button>
                <button onClick={() => setIsModerating(false)} className="text-nt-blue bg-nt-grey-light py-2 px-4 rounded-md">Cancel</button>
            </div>
        </div>
    }

    const ModerationDecision = () => {
        return <div className="flex flex-col items-center gap-5">
            {decision ? <FiCheckCircle size={48} className="text-nt-blue" /> : <FiX size={48} className="text-nt-red" />}
            {decision ? <h3 className="text-nt-blue">Tutor Accepted</h3> : <h3 className="text-nt-red">Tutor Rejected</h3>}
        </div>
    }

    return (
        <>
            {showRejectDialog && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
                <div className="w-full max-w-lg rounded-xl bg-white p-6">
                    <h3 className="text-nt-red text-lg mb-2">Reject tutor profile</h3>
                    <p className="text-nt-blue mb-4">You can add an optional note that will be sent by email to the tutor.</p>
                    <label className="text-nt-blue text-sm mb-1 block" htmlFor="reject-note">Optional note</label>
                    <textarea
                        id="reject-note"
                        value={rejectNote}
                        onChange={(e) => setRejectNote(e.target.value)}
                        rows={4}
                        className="w-full border border-nt-grey-light rounded-md p-2 text-sm text-nt-blue mb-4"
                        placeholder="Add a note for the tutor (optional)"
                    />
                    <div className="flex justify-end gap-3">
                        <button onClick={() => setShowRejectDialog(false)} className="text-nt-blue bg-nt-grey-light py-2 px-4 rounded-md">Cancel</button>
                        <button onClick={() => dispatchModerate()} className="text-white bg-nt-red py-2 px-4 rounded-md">Reject</button>
                    </div>
                </div>
            </div>}
            <div className="bg-white rounded-xl mb-5">
                <ul className="flex gap-2 p-2">
                    <li className="flex no-underline"><Link className="flex no-underline gap-2 items-center text-nt-grey after:content-['>'] " to={"/users/moderation"}><FiArrowLeft />Moderation</Link></li>
                    {!isLoading && <li className="text-nt-blue capitalize">{profile.firstName + ' ' + profile.lastName}</li>}
                </ul>
            </div>

            <div className="w-full flex gap-5">
                <div className="w-4/5">
                    {!isLoading && <SingleTutor filePreview={true} profile={profile} activeTab={activeTab} setActiveTab={setActiveTab} />}
                </div>
                <div className="w-1/5 bg-white rounded-2xl p-5 ">
                    <h3 className="text-nt-blue mb-2">Action</h3>
                    <div className="text-nt-blue mb-10">
                        <h4>Informations:</h4>
                        <p>Email: {profile.email}</p>
                        <p>phone: {profile.phone}</p>
                    </div>
                    {!moderated ? <ModerationAction /> : <ModerationDecision />}
                </div>
            </div>
        </>
    )
}

export { TutorModerate }